import styled from 'styled-components';

import { colors, fontFamily, zIndex, breakpoints } from '../../ui/variables';

const main = {
  height: {
    iphone: 48,
  },
};

export const AddUserFormStyle = styled.div`
  .add-user-form {
    ${zIndex.sky};
    overflow-y: auto;
    text-align: center;
    padding: 21px;
    position: fixed;
    top: ${main.height.iphone}px;
    height: 100%;
    max-height: calc(100vh - ${main.height.iphone}px);
    width: 100%;
    right: -120%;
    transition: 600ms right;
    background-color: ${colors.veryPaleBlue};

    .error-message {
      margin-top: 3px;
      ${fontFamily.sourceSansPro.bold};
      font-size: 14px;
      color: ${colors.softRed};
    }

    @media (min-width: ${breakpoints.ipadLandscape.width}px) {
      width: 600px;
      height: 95%;
    }
    &.opened {
      right: 0;
    }

    .add-new-institution {
      display: flex;
      justify-content: center;
      width: 100%;
      color: ${colors.softBlue};

      .text {
        margin-left: 17px;
      }

      .plus-container {
        display: flex;
        justify-content: center;
        height: 20px;
        width: 20px;
        border-radius: 50%;
        border: 2px solid ${colors.softBlue};
        svg {
          fill: ${colors.softBlue};
          height: 10px;
          width: 10px;
          align-self: center;
          justify-self: center;
        }
      }
    }

    /* .permissions {
      display: flex;
      flex-direction: column;
      align-items: flex-start; */
    /* margin-top: 10px; */

    /* .title-permissions {
        font-size: 14px;
        margin-bottom: 20px;
        ${fontFamily.sourceSansPro.bold};
      }

      .option-container {
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-bottom: 16px;

        .text-permission {
          font-size: 14px;
        }

        .check-box {
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: center;
          margin-right: 16px;

          .box {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
            height: 28px;
            width: 28px;
            background-color: white;
            border-radius: 6px;
            svg {
              fill: ${colors.limeGreen};
              width: 20px;
              height: 15px;
            }
          }
        }
      }
    } */

    .title-header {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      margin-bottom: 10px;

      .title-form {
        ${fontFamily.sourceSansPro.bold};
        font-size: 18px;
        line-height: 22px;
        margin-bottom: 15px;
      }

      .subtitle-form {
        ${fontFamily.sourceSansPro.bold};
        font-size: 14px;
      }
    }
    .close-form-button {
      position: absolute;
      right: 25px;
      top: 20px;
      font-size: 30px;
      transform: rotate(45deg);
      line-height: 1;
    }

    .inline-input-container {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      margin: 15px 0;
      .input-container {
        width: 48%;
        margin-bottom: 0;
      }
    }

    .input-container {
      margin-bottom: 15px;
      .input-label {
        display: flex;
        align-self: flex-start;
        margin-bottom: 10px;
      }
    }

    .buttons-container {
      margin-top: 40px;
      display: flex;
      justify-content: center;
      flex-direction: row;
      width: 100%;

      .button-wrapper {
        width: 90%;
      }

      .button-wrapper:first-child {
        margin-right: 21px;
      }
    }
  }
`;
